
// ReSharper disable InconsistentNaming
define('coach/cumulative/view/models/cumulative-stats-model',['jquery',
        'backbone',
        '_',
        'services',
        'usage-log-event'],
    function ($, Backbone, _, services, UsageLogEvent) {
        'use strict';

        var CumulativeStatsModel = Backbone.Model.extend({
            initialize: function (options) {
                this.attributes = this.parse(options);
            },
        });

        return CumulativeStatsModel;
    });
